import './more.component.js';
import './more.controller.js';
import './more.template.html';
import './_more.styles.scss';

angular
.module('inkfinder')
.config(function($stateProvider) {
  $stateProvider
  .state('inkfinder.more', {
    url: '/more',
    views: {
      '@': {
        component: 'inkMore'
      }
    },
    resolve: {
      $title: (() => 'Find more')
    }
  })
  .state('site.more', {
    url: '/site-more',
    views: {
      '@': {
        component: 'inkMore'
      }
    },
    resolve: {
      $title: (() => 'Find more')
    }
  });
});



// WEBPACK FOOTER //
// ./common/more/index.js